import { m as Q, a as tt } from "../mul-div-C4uXpePH.mjs";
var Ht = process.env.NODE_ENV === "production", et = "Invariant failed";
function jt(t, e) {
  if (!t) {
    if (Ht)
      throw new Error(et);
    var n = e, i = "".concat(et, ": ").concat(n);
    throw new Error(i);
  }
}
function Ft(t, e) {
  const n = t.exec(e);
  return n == null ? void 0 : n.groups;
}
const nt = /^tuple(?<array>(\[(\d*)\])*)$/;
function R(t) {
  let e = t.type;
  if (nt.test(t.type) && "components" in t) {
    e = "(";
    const n = t.components.length;
    for (let s = 0; s < n; s++) {
      const o = t.components[s];
      e += R(o), s < n - 1 && (e += ", ");
    }
    const i = Ft(nt, t.type);
    return e += `)${(i == null ? void 0 : i.array) ?? ""}`, R({
      ...t,
      type: e
    });
  }
  return "indexed" in t && t.indexed && (e = `${e} indexed`), t.name ? `${e} ${t.name}` : e;
}
function v(t) {
  let e = "";
  const n = t.length;
  for (let i = 0; i < n; i++) {
    const s = t[i];
    e += R(s), i !== n - 1 && (e += ", ");
  }
  return e;
}
function Vt(t) {
  return t.type === "function" ? `function ${t.name}(${v(t.inputs)})${t.stateMutability && t.stateMutability !== "nonpayable" ? ` ${t.stateMutability}` : ""}${t.outputs.length ? ` returns (${v(t.outputs)})` : ""}` : t.type === "event" ? `event ${t.name}(${v(t.inputs)})` : t.type === "error" ? `error ${t.name}(${v(t.inputs)})` : t.type === "constructor" ? `constructor(${v(t.inputs)})${t.stateMutability === "payable" ? " payable" : ""}` : t.type === "fallback" ? "fallback()" : "receive() external payable";
}
function N(t, { includeName: e = !1 } = {}) {
  if (t.type !== "function" && t.type !== "event" && t.type !== "error")
    throw new ee(t.type);
  return `${t.name}(${H(t.inputs, { includeName: e })})`;
}
function H(t, { includeName: e = !1 } = {}) {
  return t ? t.map((n) => Wt(n, { includeName: e })).join(e ? ", " : ",") : "";
}
function Wt(t, { includeName: e }) {
  return t.type.startsWith("tuple") ? `(${H(t.components, { includeName: e })})${t.type.slice(5)}` : t.type + (e && t.name ? ` ${t.name}` : "");
}
function S(t, { strict: e = !0 } = {}) {
  return !t || typeof t != "string" ? !1 : e ? /^0x[0-9a-fA-F]*$/.test(t) : t.startsWith("0x");
}
function l(t) {
  return S(t, { strict: !1 }) ? Math.ceil((t.length - 2) / 2) : t.length;
}
const ht = "2.21.19";
let B = {
  getDocsUrl: ({ docsBaseUrl: t, docsPath: e = "", docsSlug: n }) => e ? `${t ?? "https://viem.sh"}${e}${n ? `#${n}` : ""}` : void 0,
  version: ht
};
class p extends Error {
  constructor(e, n = {}) {
    var u;
    const i = (() => {
      var a;
      return n.cause instanceof p ? n.cause.details : (a = n.cause) != null && a.message ? n.cause.message : n.details;
    })(), s = n.cause instanceof p && n.cause.docsPath || n.docsPath, o = (u = B.getDocsUrl) == null ? void 0 : u.call(B, { ...n, docsPath: s }), r = [
      e || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...o ? [`Docs: ${o}`] : [],
      ...i ? [`Details: ${i}`] : [],
      `Version: ${B.version}`
    ].join(`
`);
    super(r, n.cause ? { cause: n.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), this.details = i, this.docsPath = s, this.metaMessages = n.metaMessages, this.name = n.name ?? this.name, this.shortMessage = e, this.version = ht;
  }
  walk(e) {
    return mt(this, e);
  }
}
function mt(t, e) {
  return e != null && e(t) ? t : t && typeof t == "object" && "cause" in t ? mt(t.cause, e) : e ? null : t;
}
class Xt extends p {
  constructor({ data: e, params: n, size: i }) {
    super([`Data size of ${i} bytes is too small for given parameters.`].join(`
`), {
      metaMessages: [
        `Params: (${H(n, { includeName: !0 })})`,
        `Data:   ${e} (${i} bytes)`
      ],
      name: "AbiDecodingDataSizeTooSmallError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "params", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "size", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = e, this.params = n, this.size = i;
  }
}
class Gt extends p {
  constructor() {
    super('Cannot decode zero data ("0x") with ABI parameters.', {
      name: "AbiDecodingZeroDataError"
    });
  }
}
class qt extends p {
  constructor({ expectedLength: e, givenLength: n, type: i }) {
    super([
      `ABI encoding array length mismatch for type ${i}.`,
      `Expected length: ${e}`,
      `Given length: ${n}`
    ].join(`
`), { name: "AbiEncodingArrayLengthMismatchError" });
  }
}
class Kt extends p {
  constructor({ expectedSize: e, value: n }) {
    super(`Size of bytes "${n}" (bytes${l(n)}) does not match expected size (bytes${e}).`, { name: "AbiEncodingBytesSizeMismatchError" });
  }
}
class Yt extends p {
  constructor({ expectedLength: e, givenLength: n }) {
    super([
      "ABI encoding params/values length mismatch.",
      `Expected length (params): ${e}`,
      `Given length (values): ${n}`
    ].join(`
`), { name: "AbiEncodingLengthMismatchError" });
  }
}
class it extends p {
  constructor(e, { docsPath: n } = {}) {
    super([
      `Function ${e ? `"${e}" ` : ""}not found on ABI.`,
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: n,
      name: "AbiFunctionNotFoundError"
    });
  }
}
class Zt extends p {
  constructor(e, n) {
    super("Found ambiguous types in overloaded ABI items.", {
      metaMessages: [
        `\`${e.type}\` in \`${N(e.abiItem)}\`, and`,
        `\`${n.type}\` in \`${N(n.abiItem)}\``,
        "",
        "These types encode differently and cannot be distinguished at runtime.",
        "Remove one of the ambiguous items in the ABI."
      ],
      name: "AbiItemAmbiguityError"
    });
  }
}
class Jt extends p {
  constructor(e, { docsPath: n }) {
    super([
      `Type "${e}" is not a valid encoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: n, name: "InvalidAbiEncodingType" });
  }
}
class Qt extends p {
  constructor(e, { docsPath: n }) {
    super([
      `Type "${e}" is not a valid decoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: n, name: "InvalidAbiDecodingType" });
  }
}
class te extends p {
  constructor(e) {
    super([`Value "${e}" is not a valid array.`].join(`
`), {
      name: "InvalidArrayError"
    });
  }
}
class ee extends p {
  constructor(e) {
    super([
      `"${e}" is not a valid definition type.`,
      'Valid types: "function", "event", "error"'
    ].join(`
`), { name: "InvalidDefinitionTypeError" });
  }
}
class gt extends p {
  constructor({ offset: e, position: n, size: i }) {
    super(`Slice ${n === "start" ? "starting" : "ending"} at offset "${e}" is out-of-bounds (size: ${i}).`, { name: "SliceOffsetOutOfBoundsError" });
  }
}
class bt extends p {
  constructor({ size: e, targetSize: n, type: i }) {
    super(`${i.charAt(0).toUpperCase()}${i.slice(1).toLowerCase()} size (${e}) exceeds padding size (${n}).`, { name: "SizeExceedsPaddingSizeError" });
  }
}
function E(t, { dir: e, size: n = 32 } = {}) {
  return typeof t == "string" ? w(t, { dir: e, size: n }) : ne(t, { dir: e, size: n });
}
function w(t, { dir: e, size: n = 32 } = {}) {
  if (n === null)
    return t;
  const i = t.replace("0x", "");
  if (i.length > n * 2)
    throw new bt({
      size: Math.ceil(i.length / 2),
      targetSize: n,
      type: "hex"
    });
  return `0x${i[e === "right" ? "padEnd" : "padStart"](n * 2, "0")}`;
}
function ne(t, { dir: e, size: n = 32 } = {}) {
  if (n === null)
    return t;
  if (t.length > n)
    throw new bt({
      size: t.length,
      targetSize: n,
      type: "bytes"
    });
  const i = new Uint8Array(n);
  for (let s = 0; s < n; s++) {
    const o = e === "right";
    i[o ? s : n - s - 1] = t[o ? s : t.length - s - 1];
  }
  return i;
}
class ie extends p {
  constructor({ max: e, min: n, signed: i, size: s, value: o }) {
    super(`Number "${o}" is not in safe ${s ? `${s * 8}-bit ${i ? "signed" : "unsigned"} ` : ""}integer range ${e ? `(${n} to ${e})` : `(above ${n})`}`, { name: "IntegerOutOfRangeError" });
  }
}
class se extends p {
  constructor(e) {
    super(`Bytes value "${e}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
      name: "InvalidBytesBooleanError"
    });
  }
}
class re extends p {
  constructor({ givenSize: e, maxSize: n }) {
    super(`Size cannot exceed ${n} bytes. Given size: ${e} bytes.`, { name: "SizeOverflowError" });
  }
}
function j(t, { dir: e = "left" } = {}) {
  let n = typeof t == "string" ? t.replace("0x", "") : t, i = 0;
  for (let s = 0; s < n.length - 1 && n[e === "left" ? s : n.length - s - 1].toString() === "0"; s++)
    i++;
  return n = e === "left" ? n.slice(i) : n.slice(0, n.length - i), typeof t == "string" ? (n.length === 1 && e === "right" && (n = `${n}0`), `0x${n.length % 2 === 1 ? `0${n}` : n}`) : n;
}
function h(t, { size: e }) {
  if (l(t) > e)
    throw new re({
      givenSize: l(t),
      maxSize: e
    });
}
function wt(t, e = {}) {
  const { signed: n } = e;
  e.size && h(t, { size: e.size });
  const i = BigInt(t);
  if (!n)
    return i;
  const s = (t.length - 2) / 2, o = (1n << BigInt(s) * 8n - 1n) - 1n;
  return i <= o ? i : i - BigInt(`0x${"f".padStart(s * 2, "f")}`) - 1n;
}
function oe(t, e = {}) {
  return Number(wt(t, e));
}
const ue = /* @__PURE__ */ Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function ae(t, e = {}) {
  return typeof t == "number" || typeof t == "bigint" ? T(t, e) : typeof t == "string" ? Tt(t, e) : typeof t == "boolean" ? xt(t, e) : x(t, e);
}
function xt(t, e = {}) {
  const n = `0x${Number(t)}`;
  return typeof e.size == "number" ? (h(n, { size: e.size }), E(n, { size: e.size })) : n;
}
function x(t, e = {}) {
  let n = "";
  for (let s = 0; s < t.length; s++)
    n += ue[t[s]];
  const i = `0x${n}`;
  return typeof e.size == "number" ? (h(i, { size: e.size }), E(i, { dir: "right", size: e.size })) : i;
}
function T(t, e = {}) {
  const { signed: n, size: i } = e, s = BigInt(t);
  let o;
  i ? n ? o = (1n << BigInt(i) * 8n - 1n) - 1n : o = 2n ** (BigInt(i) * 8n) - 1n : typeof t == "number" && (o = BigInt(Number.MAX_SAFE_INTEGER));
  const r = typeof o == "bigint" && n ? -o - 1n : 0;
  if (o && s > o || s < r) {
    const a = typeof t == "bigint" ? "n" : "";
    throw new ie({
      max: o ? `${o}${a}` : void 0,
      min: `${r}${a}`,
      signed: n,
      size: i,
      value: `${t}${a}`
    });
  }
  const u = `0x${(n && s < 0 ? (1n << BigInt(i * 8)) + BigInt(s) : s).toString(16)}`;
  return i ? E(u, { size: i }) : u;
}
const ce = /* @__PURE__ */ new TextEncoder();
function Tt(t, e = {}) {
  const n = ce.encode(t);
  return x(n, e);
}
const pe = /* @__PURE__ */ new TextEncoder();
function At(t, e = {}) {
  return typeof t == "number" || typeof t == "bigint" ? le(t, e) : typeof t == "boolean" ? fe(t, e) : S(t) ? F(t, e) : $t(t, e);
}
function fe(t, e = {}) {
  const n = new Uint8Array(1);
  return n[0] = Number(t), typeof e.size == "number" ? (h(n, { size: e.size }), E(n, { size: e.size })) : n;
}
const m = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function st(t) {
  if (t >= m.zero && t <= m.nine)
    return t - m.zero;
  if (t >= m.A && t <= m.F)
    return t - (m.A - 10);
  if (t >= m.a && t <= m.f)
    return t - (m.a - 10);
}
function F(t, e = {}) {
  let n = t;
  e.size && (h(n, { size: e.size }), n = E(n, { dir: "right", size: e.size }));
  let i = n.slice(2);
  i.length % 2 && (i = `0${i}`);
  const s = i.length / 2, o = new Uint8Array(s);
  for (let r = 0, u = 0; r < s; r++) {
    const a = st(i.charCodeAt(u++)), c = st(i.charCodeAt(u++));
    if (a === void 0 || c === void 0)
      throw new p(`Invalid byte sequence ("${i[u - 2]}${i[u - 1]}" in "${i}").`);
    o[r] = a * 16 + c;
  }
  return o;
}
function le(t, e) {
  const n = T(t, e);
  return F(n);
}
function $t(t, e = {}) {
  const n = pe.encode(t);
  return typeof e.size == "number" ? (h(n, { size: e.size }), E(n, { dir: "right", size: e.size })) : n;
}
function rt(t) {
  if (!Number.isSafeInteger(t) || t < 0)
    throw new Error(`positive integer expected, not ${t}`);
}
function de(t) {
  return t instanceof Uint8Array || t != null && typeof t == "object" && t.constructor.name === "Uint8Array";
}
function V(t, ...e) {
  if (!de(t))
    throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(t.length))
    throw new Error(`Uint8Array expected of length ${e}, not of length=${t.length}`);
}
function ot(t, e = !0) {
  if (t.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && t.finished)
    throw new Error("Hash#digest() has already been called");
}
function ye(t, e) {
  V(t);
  const n = e.outputLen;
  if (t.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const M = /* @__PURE__ */ BigInt(2 ** 32 - 1), ut = /* @__PURE__ */ BigInt(32);
function he(t, e = !1) {
  return e ? { h: Number(t & M), l: Number(t >> ut & M) } : { h: Number(t >> ut & M) | 0, l: Number(t & M) | 0 };
}
function me(t, e = !1) {
  let n = new Uint32Array(t.length), i = new Uint32Array(t.length);
  for (let s = 0; s < t.length; s++) {
    const { h: o, l: r } = he(t[s], e);
    [n[s], i[s]] = [o, r];
  }
  return [n, i];
}
const ge = (t, e, n) => t << n | e >>> 32 - n, be = (t, e, n) => e << n | t >>> 32 - n, we = (t, e, n) => e << n - 32 | t >>> 64 - n, xe = (t, e, n) => t << n - 32 | e >>> 64 - n;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Te = (t) => new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4)), at = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, Ae = (t) => t << 24 & 4278190080 | t << 8 & 16711680 | t >>> 8 & 65280 | t >>> 24 & 255;
function ct(t) {
  for (let e = 0; e < t.length; e++)
    t[e] = Ae(t[e]);
}
function $e(t) {
  if (typeof t != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof t}`);
  return new Uint8Array(new TextEncoder().encode(t));
}
function Et(t) {
  return typeof t == "string" && (t = $e(t)), V(t), t;
}
class Ee {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function ve(t) {
  const e = (i) => t().update(Et(i)).digest(), n = t();
  return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = () => t(), e;
}
const vt = [], zt = [], It = [], ze = /* @__PURE__ */ BigInt(0), z = /* @__PURE__ */ BigInt(1), Ie = /* @__PURE__ */ BigInt(2), Se = /* @__PURE__ */ BigInt(7), Be = /* @__PURE__ */ BigInt(256), Me = /* @__PURE__ */ BigInt(113);
for (let t = 0, e = z, n = 1, i = 0; t < 24; t++) {
  [n, i] = [i, (2 * n + 3 * i) % 5], vt.push(2 * (5 * i + n)), zt.push((t + 1) * (t + 2) / 2 % 64);
  let s = ze;
  for (let o = 0; o < 7; o++)
    e = (e << z ^ (e >> Se) * Me) % Be, e & Ie && (s ^= z << (z << /* @__PURE__ */ BigInt(o)) - z);
  It.push(s);
}
const [Pe, Oe] = /* @__PURE__ */ me(It, !0), pt = (t, e, n) => n > 32 ? we(t, e, n) : ge(t, e, n), ft = (t, e, n) => n > 32 ? xe(t, e, n) : be(t, e, n);
function ke(t, e = 24) {
  const n = new Uint32Array(10);
  for (let i = 24 - e; i < 24; i++) {
    for (let r = 0; r < 10; r++)
      n[r] = t[r] ^ t[r + 10] ^ t[r + 20] ^ t[r + 30] ^ t[r + 40];
    for (let r = 0; r < 10; r += 2) {
      const u = (r + 8) % 10, a = (r + 2) % 10, c = n[a], f = n[a + 1], d = pt(c, f, 1) ^ n[u], b = ft(c, f, 1) ^ n[u + 1];
      for (let y = 0; y < 50; y += 10)
        t[r + y] ^= d, t[r + y + 1] ^= b;
    }
    let s = t[2], o = t[3];
    for (let r = 0; r < 24; r++) {
      const u = zt[r], a = pt(s, o, u), c = ft(s, o, u), f = vt[r];
      s = t[f], o = t[f + 1], t[f] = a, t[f + 1] = c;
    }
    for (let r = 0; r < 50; r += 10) {
      for (let u = 0; u < 10; u++)
        n[u] = t[r + u];
      for (let u = 0; u < 10; u++)
        t[r + u] ^= ~n[(u + 2) % 10] & n[(u + 4) % 10];
    }
    t[0] ^= Pe[i], t[1] ^= Oe[i];
  }
  n.fill(0);
}
class W extends Ee {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, n, i, s = !1, o = 24) {
    if (super(), this.blockLen = e, this.suffix = n, this.outputLen = i, this.enableXOF = s, this.rounds = o, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, rt(i), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = Te(this.state);
  }
  keccak() {
    at || ct(this.state32), ke(this.state32, this.rounds), at || ct(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    ot(this);
    const { blockLen: n, state: i } = this;
    e = Et(e);
    const s = e.length;
    for (let o = 0; o < s; ) {
      const r = Math.min(n - this.pos, s - o);
      for (let u = 0; u < r; u++)
        i[this.pos++] ^= e[o++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: e, suffix: n, pos: i, blockLen: s } = this;
    e[i] ^= n, n & 128 && i === s - 1 && this.keccak(), e[s - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    ot(this, !1), V(e), this.finish();
    const n = this.state, { blockLen: i } = this;
    for (let s = 0, o = e.length; s < o; ) {
      this.posOut >= i && this.keccak();
      const r = Math.min(i - this.posOut, o - s);
      e.set(n.subarray(this.posOut, this.posOut + r), s), this.posOut += r, s += r;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return rt(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (ye(e, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(e) {
    const { blockLen: n, suffix: i, outputLen: s, rounds: o, enableXOF: r } = this;
    return e || (e = new W(n, i, s, r, o)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = o, e.suffix = i, e.outputLen = s, e.enableXOF = r, e.destroyed = this.destroyed, e;
  }
}
const Le = (t, e, n) => ve(() => new W(e, t, n)), Ue = /* @__PURE__ */ Le(1, 136, 256 / 8);
function St(t, e) {
  const n = e || "hex", i = Ue(S(t, { strict: !1 }) ? At(t) : t);
  return n === "bytes" ? i : ae(i);
}
const Re = (t) => St(At(t));
function Ne(t) {
  return Re(t);
}
function _e(t) {
  let e = !0, n = "", i = 0, s = "", o = !1;
  for (let r = 0; r < t.length; r++) {
    const u = t[r];
    if (["(", ")", ","].includes(u) && (e = !0), u === "(" && i++, u === ")" && i--, !!e) {
      if (i === 0) {
        if (u === " " && ["event", "function", ""].includes(s))
          s = "";
        else if (s += u, u === ")") {
          o = !0;
          break;
        }
        continue;
      }
      if (u === " ") {
        t[r - 1] !== "," && n !== "," && n !== ",(" && (n = "", e = !1);
        continue;
      }
      s += u, n += u;
    }
  }
  if (!o)
    throw new p("Unable to normalize signature.");
  return s;
}
const Ce = (t) => {
  const e = typeof t == "string" ? t : Vt(t);
  return _e(e);
};
function Bt(t) {
  return Ne(Ce(t));
}
const De = Bt;
class He extends p {
  constructor({ address: e }) {
    super(`Address "${e}" is invalid.`, {
      metaMessages: [
        "- Address must be a hex value of 20 bytes (40 hex characters).",
        "- Address must match its checksum counterpart."
      ],
      name: "InvalidAddressError"
    });
  }
}
class Mt extends Map {
  constructor(e) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = e;
  }
  get(e) {
    const n = super.get(e);
    return super.has(e) && n !== void 0 && (this.delete(e), super.set(e, n)), n;
  }
  set(e, n) {
    if (super.set(e, n), this.maxSize && this.size > this.maxSize) {
      const i = this.keys().next().value;
      i && this.delete(i);
    }
    return this;
  }
}
const L = /* @__PURE__ */ new Mt(8192);
function O(t, e) {
  if (L.has(`${t}.${e}`))
    return L.get(`${t}.${e}`);
  const n = t.substring(2).toLowerCase(), i = St($t(n), "bytes"), s = n.split("");
  for (let r = 0; r < 40; r += 2)
    i[r >> 1] >> 4 >= 8 && s[r] && (s[r] = s[r].toUpperCase()), (i[r >> 1] & 15) >= 8 && s[r + 1] && (s[r + 1] = s[r + 1].toUpperCase());
  const o = `0x${s.join("")}`;
  return L.set(`${t}.${e}`, o), o;
}
const je = /^0x[a-fA-F0-9]{40}$/, U = /* @__PURE__ */ new Mt(8192);
function k(t, e) {
  const { strict: n = !0 } = e ?? {}, i = `${t}.${n}`;
  if (U.has(i))
    return U.get(i);
  const s = je.test(t) ? t.toLowerCase() === t ? !0 : n ? O(t) === t : !0 : !1;
  return U.set(i, s), s;
}
function $(t) {
  return typeof t[0] == "string" ? Pt(t) : Fe(t);
}
function Fe(t) {
  let e = 0;
  for (const s of t)
    e += s.length;
  const n = new Uint8Array(e);
  let i = 0;
  for (const s of t)
    n.set(s, i), i += s.length;
  return n;
}
function Pt(t) {
  return `0x${t.reduce((e, n) => e + n.replace("0x", ""), "")}`;
}
function Ot(t, e, n, { strict: i } = {}) {
  return S(t, { strict: !1 }) ? Ve(t, e, n, {
    strict: i
  }) : Ut(t, e, n, {
    strict: i
  });
}
function kt(t, e) {
  if (typeof e == "number" && e > 0 && e > l(t) - 1)
    throw new gt({
      offset: e,
      position: "start",
      size: l(t)
    });
}
function Lt(t, e, n) {
  if (typeof e == "number" && typeof n == "number" && l(t) !== n - e)
    throw new gt({
      offset: n,
      position: "end",
      size: l(t)
    });
}
function Ut(t, e, n, { strict: i } = {}) {
  kt(t, e);
  const s = t.slice(e, n);
  return i && Lt(s, e, n), s;
}
function Ve(t, e, n, { strict: i } = {}) {
  kt(t, e);
  const s = `0x${t.replace("0x", "").slice((e ?? 0) * 2, (n ?? t.length) * 2)}`;
  return i && Lt(s, e, n), s;
}
function X(t, e) {
  if (t.length !== e.length)
    throw new Yt({
      expectedLength: t.length,
      givenLength: e.length
    });
  const n = We({
    params: t,
    values: e
  }), i = q(n);
  return i.length === 0 ? "0x" : i;
}
function We({ params: t, values: e }) {
  const n = [];
  for (let i = 0; i < t.length; i++)
    n.push(G({ param: t[i], value: e[i] }));
  return n;
}
function G({ param: t, value: e }) {
  const n = K(t.type);
  if (n) {
    const [i, s] = n;
    return Ge(e, { length: i, param: { ...t, type: s } });
  }
  if (t.type === "tuple")
    return Je(e, {
      param: t
    });
  if (t.type === "address")
    return Xe(e);
  if (t.type === "bool")
    return Ke(e);
  if (t.type.startsWith("uint") || t.type.startsWith("int")) {
    const i = t.type.startsWith("int");
    return Ye(e, { signed: i });
  }
  if (t.type.startsWith("bytes"))
    return qe(e, { param: t });
  if (t.type === "string")
    return Ze(e);
  throw new Jt(t.type, {
    docsPath: "/docs/contract/encodeAbiParameters"
  });
}
function q(t) {
  let e = 0;
  for (let o = 0; o < t.length; o++) {
    const { dynamic: r, encoded: u } = t[o];
    r ? e += 32 : e += l(u);
  }
  const n = [], i = [];
  let s = 0;
  for (let o = 0; o < t.length; o++) {
    const { dynamic: r, encoded: u } = t[o];
    r ? (n.push(T(e + s, { size: 32 })), i.push(u), s += l(u)) : n.push(u);
  }
  return $([...n, ...i]);
}
function Xe(t) {
  if (!k(t))
    throw new He({ address: t });
  return { dynamic: !1, encoded: w(t.toLowerCase()) };
}
function Ge(t, { length: e, param: n }) {
  const i = e === null;
  if (!Array.isArray(t))
    throw new te(t);
  if (!i && t.length !== e)
    throw new qt({
      expectedLength: e,
      givenLength: t.length,
      type: `${n.type}[${e}]`
    });
  let s = !1;
  const o = [];
  for (let r = 0; r < t.length; r++) {
    const u = G({ param: n, value: t[r] });
    u.dynamic && (s = !0), o.push(u);
  }
  if (i || s) {
    const r = q(o);
    if (i) {
      const u = T(o.length, { size: 32 });
      return {
        dynamic: !0,
        encoded: o.length > 0 ? $([u, r]) : u
      };
    }
    if (s)
      return { dynamic: !0, encoded: r };
  }
  return {
    dynamic: !1,
    encoded: $(o.map(({ encoded: r }) => r))
  };
}
function qe(t, { param: e }) {
  const [, n] = e.type.split("bytes"), i = l(t);
  if (!n) {
    let s = t;
    return i % 32 !== 0 && (s = w(s, {
      dir: "right",
      size: Math.ceil((t.length - 2) / 2 / 32) * 32
    })), {
      dynamic: !0,
      encoded: $([w(T(i, { size: 32 })), s])
    };
  }
  if (i !== Number.parseInt(n))
    throw new Kt({
      expectedSize: Number.parseInt(n),
      value: t
    });
  return { dynamic: !1, encoded: w(t, { dir: "right" }) };
}
function Ke(t) {
  if (typeof t != "boolean")
    throw new p(`Invalid boolean value: "${t}" (type: ${typeof t}). Expected: \`true\` or \`false\`.`);
  return { dynamic: !1, encoded: w(xt(t)) };
}
function Ye(t, { signed: e }) {
  return {
    dynamic: !1,
    encoded: T(t, {
      size: 32,
      signed: e
    })
  };
}
function Ze(t) {
  const e = Tt(t), n = Math.ceil(l(e) / 32), i = [];
  for (let s = 0; s < n; s++)
    i.push(w(Ot(e, s * 32, (s + 1) * 32), {
      dir: "right"
    }));
  return {
    dynamic: !0,
    encoded: $([
      w(T(l(e), { size: 32 })),
      ...i
    ])
  };
}
function Je(t, { param: e }) {
  let n = !1;
  const i = [];
  for (let s = 0; s < e.components.length; s++) {
    const o = e.components[s], r = Array.isArray(t) ? s : o.name, u = G({
      param: o,
      value: t[r]
    });
    i.push(u), u.dynamic && (n = !0);
  }
  return {
    dynamic: n,
    encoded: n ? q(i) : $(i.map(({ encoded: s }) => s))
  };
}
function K(t) {
  const e = t.match(/^(.*)\[(\d+)?\]$/);
  return e ? (
    // Return `null` if the array is dynamic.
    [e[2] ? Number(e[2]) : null, e[1]]
  ) : void 0;
}
const Rt = (t) => Ot(Bt(t), 0, 4);
function Qe(t) {
  const { abi: e, args: n = [], name: i } = t, s = S(i, { strict: !1 }), o = e.filter((u) => s ? u.type === "function" ? Rt(u) === i : u.type === "event" ? De(u) === i : !1 : "name" in u && u.name === i);
  if (o.length === 0)
    return;
  if (o.length === 1)
    return o[0];
  let r;
  for (const u of o) {
    if (!("inputs" in u))
      continue;
    if (!n || n.length === 0) {
      if (!u.inputs || u.inputs.length === 0)
        return u;
      continue;
    }
    if (!u.inputs || u.inputs.length === 0 || u.inputs.length !== n.length)
      continue;
    if (n.every((c, f) => {
      const d = "inputs" in u && u.inputs[f];
      return d ? _(c, d) : !1;
    })) {
      if (r && "inputs" in r && r.inputs) {
        const c = Nt(u.inputs, r.inputs, n);
        if (c)
          throw new Zt({
            abiItem: u,
            type: c[0]
          }, {
            abiItem: r,
            type: c[1]
          });
      }
      r = u;
    }
  }
  return r || o[0];
}
function _(t, e) {
  const n = typeof t, i = e.type;
  switch (i) {
    case "address":
      return k(t, { strict: !1 });
    case "bool":
      return n === "boolean";
    case "function":
      return n === "string";
    case "string":
      return n === "string";
    default:
      return i === "tuple" && "components" in e ? Object.values(e.components).every((s, o) => _(Object.values(t)[o], s)) : /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(i) ? n === "number" || n === "bigint" : /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(i) ? n === "string" || t instanceof Uint8Array : /[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(i) ? Array.isArray(t) && t.every((s) => _(s, {
        ...e,
        // Pop off `[]` or `[M]` from end of type
        type: i.replace(/(\[[0-9]{0,}\])$/, "")
      })) : !1;
  }
}
function Nt(t, e, n) {
  for (const i in t) {
    const s = t[i], o = e[i];
    if (s.type === "tuple" && o.type === "tuple" && "components" in s && "components" in o)
      return Nt(s.components, o.components, n[i]);
    const r = [s.type, o.type];
    if (r.includes("address") && r.includes("bytes20") ? !0 : r.includes("address") && r.includes("string") ? k(n[i], { strict: !1 }) : r.includes("address") && r.includes("bytes") ? k(n[i], { strict: !1 }) : !1)
      return r;
  }
}
const lt = "/docs/contract/encodeFunctionData";
function tn(t) {
  const { abi: e, args: n, functionName: i } = t;
  let s = e[0];
  if (i) {
    const o = Qe({
      abi: e,
      args: n,
      name: i
    });
    if (!o)
      throw new it(i, { docsPath: lt });
    s = o;
  }
  if (s.type !== "function")
    throw new it(void 0, { docsPath: lt });
  return {
    abi: [s],
    functionName: Rt(N(s))
  };
}
function _t(t) {
  const { args: e } = t, { abi: n, functionName: i } = (() => {
    var u;
    return t.abi.length === 1 && ((u = t.functionName) != null && u.startsWith("0x")) ? t : tn(t);
  })(), s = n[0], o = i, r = "inputs" in s && s.inputs ? X(s.inputs, e ?? []) : void 0;
  return Pt([o, r ?? "0x"]);
}
class dt extends p {
  constructor({ offset: e }) {
    super(`Offset \`${e}\` cannot be negative.`, {
      name: "NegativeOffsetError"
    });
  }
}
class en extends p {
  constructor({ length: e, position: n }) {
    super(`Position \`${n}\` is out of bounds (\`0 < position < ${e}\`).`, { name: "PositionOutOfBoundsError" });
  }
}
class nn extends p {
  constructor({ count: e, limit: n }) {
    super(`Recursive read limit of \`${n}\` exceeded (recursive read count: \`${e}\`).`, { name: "RecursiveReadLimitExceededError" });
  }
}
const sn = {
  bytes: new Uint8Array(),
  dataView: new DataView(new ArrayBuffer(0)),
  position: 0,
  positionReadCount: /* @__PURE__ */ new Map(),
  recursiveReadCount: 0,
  recursiveReadLimit: Number.POSITIVE_INFINITY,
  assertReadLimit() {
    if (this.recursiveReadCount >= this.recursiveReadLimit)
      throw new nn({
        count: this.recursiveReadCount + 1,
        limit: this.recursiveReadLimit
      });
  },
  assertPosition(t) {
    if (t < 0 || t > this.bytes.length - 1)
      throw new en({
        length: this.bytes.length,
        position: t
      });
  },
  decrementPosition(t) {
    if (t < 0)
      throw new dt({ offset: t });
    const e = this.position - t;
    this.assertPosition(e), this.position = e;
  },
  getReadCount(t) {
    return this.positionReadCount.get(t || this.position) || 0;
  },
  incrementPosition(t) {
    if (t < 0)
      throw new dt({ offset: t });
    const e = this.position + t;
    this.assertPosition(e), this.position = e;
  },
  inspectByte(t) {
    const e = t ?? this.position;
    return this.assertPosition(e), this.bytes[e];
  },
  inspectBytes(t, e) {
    const n = e ?? this.position;
    return this.assertPosition(n + t - 1), this.bytes.subarray(n, n + t);
  },
  inspectUint8(t) {
    const e = t ?? this.position;
    return this.assertPosition(e), this.bytes[e];
  },
  inspectUint16(t) {
    const e = t ?? this.position;
    return this.assertPosition(e + 1), this.dataView.getUint16(e);
  },
  inspectUint24(t) {
    const e = t ?? this.position;
    return this.assertPosition(e + 2), (this.dataView.getUint16(e) << 8) + this.dataView.getUint8(e + 2);
  },
  inspectUint32(t) {
    const e = t ?? this.position;
    return this.assertPosition(e + 3), this.dataView.getUint32(e);
  },
  pushByte(t) {
    this.assertPosition(this.position), this.bytes[this.position] = t, this.position++;
  },
  pushBytes(t) {
    this.assertPosition(this.position + t.length - 1), this.bytes.set(t, this.position), this.position += t.length;
  },
  pushUint8(t) {
    this.assertPosition(this.position), this.bytes[this.position] = t, this.position++;
  },
  pushUint16(t) {
    this.assertPosition(this.position + 1), this.dataView.setUint16(this.position, t), this.position += 2;
  },
  pushUint24(t) {
    this.assertPosition(this.position + 2), this.dataView.setUint16(this.position, t >> 8), this.dataView.setUint8(this.position + 2, t & 255), this.position += 3;
  },
  pushUint32(t) {
    this.assertPosition(this.position + 3), this.dataView.setUint32(this.position, t), this.position += 4;
  },
  readByte() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectByte();
    return this.position++, t;
  },
  readBytes(t, e) {
    this.assertReadLimit(), this._touch();
    const n = this.inspectBytes(t);
    return this.position += e ?? t, n;
  },
  readUint8() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectUint8();
    return this.position += 1, t;
  },
  readUint16() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectUint16();
    return this.position += 2, t;
  },
  readUint24() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectUint24();
    return this.position += 3, t;
  },
  readUint32() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectUint32();
    return this.position += 4, t;
  },
  get remaining() {
    return this.bytes.length - this.position;
  },
  setPosition(t) {
    const e = this.position;
    return this.assertPosition(t), this.position = t, () => this.position = e;
  },
  _touch() {
    if (this.recursiveReadLimit === Number.POSITIVE_INFINITY)
      return;
    const t = this.getReadCount();
    this.positionReadCount.set(this.position, t + 1), t > 0 && this.recursiveReadCount++;
  }
};
function rn(t, { recursiveReadLimit: e = 8192 } = {}) {
  const n = Object.create(sn);
  return n.bytes = t, n.dataView = new DataView(t.buffer, t.byteOffset, t.byteLength), n.positionReadCount = /* @__PURE__ */ new Map(), n.recursiveReadLimit = e, n;
}
function on(t, e = {}) {
  typeof e.size < "u" && h(t, { size: e.size });
  const n = x(t, e);
  return wt(n, e);
}
function un(t, e = {}) {
  let n = t;
  if (typeof e.size < "u" && (h(n, { size: e.size }), n = j(n)), n.length > 1 || n[0] > 1)
    throw new se(n);
  return !!n[0];
}
function g(t, e = {}) {
  typeof e.size < "u" && h(t, { size: e.size });
  const n = x(t, e);
  return oe(n, e);
}
function an(t, e = {}) {
  let n = t;
  return typeof e.size < "u" && (h(n, { size: e.size }), n = j(n, { dir: "right" })), new TextDecoder().decode(n);
}
function cn(t, e) {
  const n = typeof e == "string" ? F(e) : e, i = rn(n);
  if (l(n) === 0 && t.length > 0)
    throw new Gt();
  if (l(e) && l(e) < 32)
    throw new Xt({
      data: typeof e == "string" ? e : x(e),
      params: t,
      size: l(e)
    });
  let s = 0;
  const o = [];
  for (let r = 0; r < t.length; ++r) {
    const u = t[r];
    i.setPosition(s);
    const [a, c] = A(i, u, {
      staticPosition: 0
    });
    s += c, o.push(a);
  }
  return o;
}
function A(t, e, { staticPosition: n }) {
  const i = K(e.type);
  if (i) {
    const [s, o] = i;
    return fn(t, { ...e, type: o }, { length: s, staticPosition: n });
  }
  if (e.type === "tuple")
    return hn(t, e, { staticPosition: n });
  if (e.type === "address")
    return pn(t);
  if (e.type === "bool")
    return ln(t);
  if (e.type.startsWith("bytes"))
    return dn(t, e, { staticPosition: n });
  if (e.type.startsWith("uint") || e.type.startsWith("int"))
    return yn(t, e);
  if (e.type === "string")
    return mn(t, { staticPosition: n });
  throw new Qt(e.type, {
    docsPath: "/docs/contract/decodeAbiParameters"
  });
}
const yt = 32, C = 32;
function pn(t) {
  const e = t.readBytes(32);
  return [O(x(Ut(e, -20))), 32];
}
function fn(t, e, { length: n, staticPosition: i }) {
  if (!n) {
    const r = g(t.readBytes(C)), u = i + r, a = u + yt;
    t.setPosition(u);
    const c = g(t.readBytes(yt)), f = I(e);
    let d = 0;
    const b = [];
    for (let y = 0; y < c; ++y) {
      t.setPosition(a + (f ? y * 32 : d));
      const [Y, Z] = A(t, e, {
        staticPosition: a
      });
      d += Z, b.push(Y);
    }
    return t.setPosition(i + 32), [b, 32];
  }
  if (I(e)) {
    const r = g(t.readBytes(C)), u = i + r, a = [];
    for (let c = 0; c < n; ++c) {
      t.setPosition(u + c * 32);
      const [f] = A(t, e, {
        staticPosition: u
      });
      a.push(f);
    }
    return t.setPosition(i + 32), [a, 32];
  }
  let s = 0;
  const o = [];
  for (let r = 0; r < n; ++r) {
    const [u, a] = A(t, e, {
      staticPosition: i + s
    });
    s += a, o.push(u);
  }
  return [o, s];
}
function ln(t) {
  return [un(t.readBytes(32), { size: 32 }), 32];
}
function dn(t, e, { staticPosition: n }) {
  const [i, s] = e.type.split("bytes");
  if (!s) {
    const r = g(t.readBytes(32));
    t.setPosition(n + r);
    const u = g(t.readBytes(32));
    if (u === 0)
      return t.setPosition(n + 32), ["0x", 32];
    const a = t.readBytes(u);
    return t.setPosition(n + 32), [x(a), 32];
  }
  return [x(t.readBytes(Number.parseInt(s), 32)), 32];
}
function yn(t, e) {
  const n = e.type.startsWith("int"), i = Number.parseInt(e.type.split("int")[1] || "256"), s = t.readBytes(32);
  return [
    i > 48 ? on(s, { signed: n }) : g(s, { signed: n }),
    32
  ];
}
function hn(t, e, { staticPosition: n }) {
  const i = e.components.length === 0 || e.components.some(({ name: r }) => !r), s = i ? [] : {};
  let o = 0;
  if (I(e)) {
    const r = g(t.readBytes(C)), u = n + r;
    for (let a = 0; a < e.components.length; ++a) {
      const c = e.components[a];
      t.setPosition(u + o);
      const [f, d] = A(t, c, {
        staticPosition: u
      });
      o += d, s[i ? a : c == null ? void 0 : c.name] = f;
    }
    return t.setPosition(n + 32), [s, 32];
  }
  for (let r = 0; r < e.components.length; ++r) {
    const u = e.components[r], [a, c] = A(t, u, {
      staticPosition: n
    });
    s[i ? r : u == null ? void 0 : u.name] = a, o += c;
  }
  return [s, o];
}
function mn(t, { staticPosition: e }) {
  const n = g(t.readBytes(32)), i = e + n;
  t.setPosition(i);
  const s = g(t.readBytes(32));
  if (s === 0)
    return t.setPosition(e + 32), ["", 32];
  const o = t.readBytes(s, 32), r = an(j(o));
  return t.setPosition(e + 32), [r, 32];
}
function I(t) {
  var i;
  const { type: e } = t;
  if (e === "string" || e === "bytes" || e.endsWith("[]"))
    return !0;
  if (e === "tuple")
    return (i = t.components) == null ? void 0 : i.some(I);
  const n = K(t.type);
  return !!(n && I({ ...t, type: n[1] }));
}
const gn = "0x0000000000000000000000000000000000000000000000000000000000000000", bn = 10000n, P = 10000n;
function In({
  vault: t,
  amountIn: e,
  tokenIn: n,
  sqrtPriceX96: i,
  unusedAssetsTolerance: s = 1n,
  // 0.01%
  slippageBuffer: o = 5n,
  // 0.05%
  maxIterations: r = 1e4,
  mode: u = "exact-input"
}) {
  console.log("computeSwapAndDeposit", {
    vault: t,
    amountIn: e,
    tokenIn: n,
    sqrtPriceX96: i,
    unusedAssetsTolerance: s,
    slippageBuffer: o,
    maxIterations: r
  });
  const a = O(n) === O(t.token1), c = {
    vault: t,
    forToken0: a,
    amountIn: e,
    sqrtPriceX96: i,
    unusedAssetsTolerance: s
  }, f = wn(c, 0n, e, r), d = D(
    f,
    i,
    c.forToken0
  );
  if (u === "exact-input") {
    const J = (e - f) * (P - o) / P;
    return {
      swapAmountIn: f,
      amount0Max: a ? d : J,
      amount1Max: a ? J : d
    };
  }
  const b = d * (P - o) / P, y = c.amountIn - f;
  return {
    swapAmountOut: b,
    amount0Max: a ? b : y,
    amount1Max: a ? y : b
  };
}
function wn(t, e, n, i) {
  let s = e, o = n;
  for (let r = 0; r < i; r++) {
    const u = s + (o - s) / 2n, [a, c] = xn(t, u);
    if (a) return u;
    c > u ? s = u + 1n : o = c, jt(r < i, "SwapResolverActions__MaxIterationsReached");
  }
  return n;
}
function xn(t, e) {
  const { mintAmount0: n, mintAmount1: i } = Tn(t, e), s = D(n, t.sqrtPriceX96, !1), o = D(i, t.sqrtPriceX96, !0), [r, u] = An(
    t.amountIn,
    t.forToken0 ? s + i : o + n
  );
  return u && t.amountIn * t.unusedAssetsTolerance / bn >= r ? [!0, e] : [!1, $n(
    t.amountIn,
    t.forToken0 ? i : n,
    t.forToken0 ? s : o
  ) ? t.amountIn : e];
}
function Tn(t, e) {
  const n = t.forToken0 ? Q : t.amountIn - e, i = t.forToken0 ? t.amountIn - e : Q, [s, o, r] = t.vault.previewMint(
    n,
    i
  );
  return { mintAmount0: o, mintAmount1: r };
}
function An(t, e) {
  const n = e - t;
  return n < 0n ? [-n, !0] : [n, !1];
}
function $n(t, e, n) {
  return e + n > t;
}
function D(t, e, n) {
  const i = e * e;
  return n ? tt(t, 1n << 192n, i) : tt(t, i, 1n << 192n);
}
const Ct = [
  {
    inputs: [
      { internalType: "address", name: "_factory", type: "address" },
      { internalType: "address", name: "_WETH9", type: "address" }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WETH9",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "bytes", name: "path", type: "bytes" },
          { internalType: "address", name: "recipient", type: "address" },
          { internalType: "uint256", name: "deadline", type: "uint256" },
          { internalType: "uint256", name: "amountIn", type: "uint256" },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256"
          }
        ],
        internalType: "struct ISwapRouter.ExactInputParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactInput",
    outputs: [{ internalType: "uint256", name: "amountOut", type: "uint256" }],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "tokenIn", type: "address" },
          { internalType: "address", name: "tokenOut", type: "address" },
          { internalType: "uint24", name: "fee", type: "uint24" },
          { internalType: "address", name: "recipient", type: "address" },
          { internalType: "uint256", name: "deadline", type: "uint256" },
          { internalType: "uint256", name: "amountIn", type: "uint256" },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256"
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct ISwapRouter.ExactInputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactInputSingle",
    outputs: [{ internalType: "uint256", name: "amountOut", type: "uint256" }],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "bytes", name: "path", type: "bytes" },
          { internalType: "address", name: "recipient", type: "address" },
          { internalType: "uint256", name: "deadline", type: "uint256" },
          { internalType: "uint256", name: "amountOut", type: "uint256" },
          { internalType: "uint256", name: "amountInMaximum", type: "uint256" }
        ],
        internalType: "struct ISwapRouter.ExactOutputParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactOutput",
    outputs: [{ internalType: "uint256", name: "amountIn", type: "uint256" }],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "tokenIn", type: "address" },
          { internalType: "address", name: "tokenOut", type: "address" },
          { internalType: "uint24", name: "fee", type: "uint24" },
          { internalType: "address", name: "recipient", type: "address" },
          { internalType: "uint256", name: "deadline", type: "uint256" },
          { internalType: "uint256", name: "amountOut", type: "uint256" },
          { internalType: "uint256", name: "amountInMaximum", type: "uint256" },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct ISwapRouter.ExactOutputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactOutputSingle",
    outputs: [{ internalType: "uint256", name: "amountIn", type: "uint256" }],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes[]", name: "data", type: "bytes[]" }],
    name: "multicall",
    outputs: [{ internalType: "bytes[]", name: "results", type: "bytes[]" }],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "refundETH",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "token", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "selfPermit",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "token", type: "address" },
      { internalType: "uint256", name: "nonce", type: "uint256" },
      { internalType: "uint256", name: "expiry", type: "uint256" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "selfPermitAllowed",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "token", type: "address" },
      { internalType: "uint256", name: "nonce", type: "uint256" },
      { internalType: "uint256", name: "expiry", type: "uint256" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "selfPermitAllowedIfNecessary",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "token", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "selfPermitIfNecessary",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "token", type: "address" },
      { internalType: "uint256", name: "amountMinimum", type: "uint256" },
      { internalType: "address", name: "recipient", type: "address" }
    ],
    name: "sweepToken",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "token", type: "address" },
      { internalType: "uint256", name: "amountMinimum", type: "uint256" },
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "feeBips", type: "uint256" },
      { internalType: "address", name: "feeRecipient", type: "address" }
    ],
    name: "sweepTokenWithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "int256", name: "amount0Delta", type: "int256" },
      { internalType: "int256", name: "amount1Delta", type: "int256" },
      { internalType: "bytes", name: "_data", type: "bytes" }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "amountMinimum", type: "uint256" },
      { internalType: "address", name: "recipient", type: "address" }
    ],
    name: "unwrapWETH9",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "amountMinimum", type: "uint256" },
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "feeBips", type: "uint256" },
      { internalType: "address", name: "feeRecipient", type: "address" }
    ],
    name: "unwrapWETH9WithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  { stateMutability: "payable", type: "receive" }
], Dt = [
  {
    type: "tuple",
    name: "swapActionPayload",
    components: [
      { type: "address", name: "swapper" },
      { type: "address", name: "tokenIn" },
      { type: "address", name: "tokenOut" },
      { type: "uint256", name: "amountInMax" },
      { type: "uint256", name: "amountOutMin" },
      { type: "bytes", name: "swapPayload" }
    ]
  }
];
function Sn({
  swapper: t,
  tokenIn: e,
  tokenOut: n,
  fee: i,
  recipient: s,
  deadline: o,
  amountIn: r,
  amountOutMinimum: u,
  sqrtPriceLimitX96: a
}) {
  const c = _t({
    abi: Ct,
    functionName: "exactInputSingle",
    args: [
      {
        tokenIn: e,
        tokenOut: n,
        fee: i,
        recipient: s,
        deadline: o,
        amountIn: r,
        amountOutMinimum: u,
        sqrtPriceLimitX96: a
      }
    ]
  });
  return X(Dt, [
    {
      swapper: t,
      tokenIn: e,
      tokenOut: n,
      amountInMax: r,
      amountOutMin: u,
      swapPayload: c
    }
  ]);
}
function Bn({
  swapper: t,
  tokenIn: e,
  tokenOut: n,
  fee: i,
  recipient: s,
  deadline: o,
  amountInMaximum: r,
  amountOut: u,
  sqrtPriceLimitX96: a
}) {
  const c = _t({
    abi: Ct,
    functionName: "exactOutputSingle",
    args: [
      {
        tokenIn: e,
        tokenOut: n,
        fee: i,
        recipient: s,
        deadline: o,
        amountInMaximum: r,
        amountOut: u,
        sqrtPriceLimitX96: a
      }
    ]
  });
  return X(Dt, [
    {
      swapper: t,
      tokenIn: e,
      tokenOut: n,
      amountInMax: r,
      amountOutMin: u,
      swapPayload: c
    }
  ]);
}
function Mn(t) {
  if (t === gn)
    return {
      lockedTokens: []
    };
  const [[e]] = cn(
    [
      {
        type: "tuple",
        name: "lockedTokens",
        components: [
          {
            type: "tuple[]",
            components: [
              { type: "uint256", name: "id" },
              { type: "int24", name: "tickLower" },
              { type: "uint128", name: "shares" },
              { type: "uint128", name: "liquidity" }
            ]
          }
        ]
      }
    ],
    t
  );
  return {
    lockedTokens: e.map((n) => ({
      id: n.id,
      tickLower: n.tickLower,
      shares: n.shares
    }))
  };
}
export {
  In as computeSwapAndDeposit,
  Mn as decodeStrykeRedeemContext,
  Sn as encodeUniswapV3ExactInputSingle,
  Bn as encodeUniswapV3ExactOutputSingle
};
